import ManaWorld from '../../../logic/loop/ManaWorld'
import PhysicsWorld from '../../../logic/loop/PhysicsWorld'
import Player from '../../../logic/physics/Player'
import GameGlobals from '../GameGlobals'
import GamePage from '../GamePage'

export default function SandboxPage() {

	return (
		<GamePage
			allowImportExport
			sandboxMode

			onLoaded={(world: PhysicsWorld) => {
				const player = new Player({
					world,

					x: 150,
					y: 150
				})

				player.setManaWorld(new ManaWorld(player))
				GameGlobals.setSelectedEntity(player)

				world.add(player)
			}}
		/>
	)
}
